import { useState } from "react";
import abhijeet from "../../Assets/Leader/Abhijeet.jpeg";
import arpit from "../../Assets/Leader/arpit.png";
import chinmoy from "../../Assets/Leader/chinmoy.jpg";
import devashis from "../../Assets/Leader/devashis.jpg";
import irfan from "../../Assets/Leader/Irfan.jpeg";
import lakshmanan from "../../Assets/Leader/lakshmanan.jpg";
import manprit from "../../Assets/Leader/manprit.jpeg";
import srikant from "../../Assets/Leader/srikant.jpg";
import venkatesh from "../../Assets/Leader/venkatesh.jpg";
import ali from "../../Assets/Leader/ali.jpeg";

const getAvatarStyle = (index) =>
  index === 0
    ? "linear-gradient(135deg, #cbd5e1, #94a3b8)"
    : "linear-gradient(135deg, #22d3ee, #0891b2)";

// ── Data ─────────────────────────────────────────────────────────────────────
const SECTIONS = [
  // {
  //   title: "People Behind",
  //   highlight: "Our Vision",
  //   members: [
  //     {
  //       name: "Srikanta Sahoo",
  //       role: "Founder & CEO",
  //       img: srikant,
  //       initials: "SS",
  //       linkedin: "https://www.linkedin.com/in/srikantasahoo/",
  //     },
  //     {
  //       name: "Arpit Nayak",
  //       img: arpit,
  //       role: "Co-Founder & Managing Director",
  //       initials: "AN",
  //       linkedin: "https://www.linkedin.com/in/arpit-nayak-8776499/",
  //     },
  //   ],
  // },
  {
    title: "Leadership Team",
    highlight: "(North America)",
    members: [
      {
        name: "Srikanta Sahoo",
        role: "Founder and CEO",
        img: srikant,
        initials: "SS",
        linkedin: "https://www.linkedin.com/in/srikantasahoo/",
      },
      {
        name: "Lakshmanan Viswanathan",
        role: "Supply chain Head",
        img: lakshmanan,
        initials: "RM",
        linkedin: "https://www.linkedin.com/in/lakshmanan-viswanathan-a82396b/",
      },
      {
        name: "Devashis Sarangi",
        role: "AI and Data Head",
        img: devashis,
        initials: "DK",
        linkedin: "https://www.linkedin.com/in/devashis/",
      },
    ],
  },
  {
    title: "Leadership Team",
    highlight: "(ASIA)",
    members: [
      // {
      //   name: "Arpit Nayak",
      //   role: "Co-Founder & Managing Director",
      //   img: arpit,
      //   initials: "AN",
      //   linkedin: "https://www.linkedin.com/in/arpit-nayak-8776499/",
      // },
      {
        name: "Chinmoy Mishra",
        role: "Chief Operating Officer",
        img: chinmoy,
        initials: "CM",
        linkedin: "https://www.linkedin.com/in/chinmoy-mishra-520606102/",
      },
      { name: "Mohammad Irfan", role: "Vice President - Sales" ,img: irfan, initials: "MI" },
      { name: "Abhijit Samantray", role: "HR Head",img: abhijeet, initials: "AS" },
      { name: "Manpreet Singh", role: "Service Delivery Head",img: manprit, initials: "MS" },
    ],
  },
  {
    title: "Leadership Team",
    highlight: "(Middle East)",
    members: [
      {
        name: "Liakat Ali Khan",
        role: "Senior Vice President - Sales",
        img: ali,
        initials: "AK",
      },
    ],
  },
  // {
  //   title: "Global Advisory",
  //   highlight: "Board",
  //   members: [
  //     {
  //       name: "Venkatesh Damodaran",
  //       role: "CEO HiView",
  //       img: venkatesh,
  //       initials: "VD",
  //       linkedin:"https://www.linkedin.com/in/venkatesh-damodaran/",
  //     },
  //   ],
  // },
];

// ── Sub-components ────────────────────────────────────────────────────────────
const LinkedInIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="white"
  >
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
  </svg>
);

const MemberCard = ({ member, index }) => {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      className="flex flex-col items-center group"
      style={{
        animation: `fadeSlideUp 0.5s ease both`,
        animationDelay: `${index * 120}ms`,
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div
        className="relative mb-5"
        style={{
          transition: "transform 0.3s ease",
          transform: hovered ? "translateY(-6px)" : "translateY(0)",
        }}
      >

        <div
          className="relative size-48 rounded-full flex items-center justify-center overflow-hidden"
          style={{
            background: getAvatarStyle(index),
             border: "4px solid #0ea5e9",
            boxShadow: hovered
              ? "0 16px 40px rgba(14, 165, 233, 0.25)"
              : "0 8px 20px rgba(0,0,0,0.1)",
            transition: "box-shadow 0.3s ease",
          }}
        >
          <img src={`${member.img}`} alt={`${member.name}`} className="object-cover size-48" />
        </div>
      </div>

      <h3 className="font-bold text-gray-800 lg:text-xl mb-0.5 text-center">
        {member.name}
      </h3>
      <p
        className="text-gray-500 text-center mb-3"
        style={{ fontSize: "0.875rem", minHeight: "2.5rem" }}
      >
        {member.role}
      </p>

      <a
            href={member.linkedin || "#"}
            target={member.linkedin ? "_blank" : "_self"}
            rel="noopener noreferrer"
            onClick={(e) => {
              if (!member.linkedin) e.preventDefault();
            }}
            className={`flex items-center cursor-pointe justify-center rounded-lg `}
            style={{
              width: "36px",
              height: "36px",
              background:
                 hovered
                  ? "linear-gradient(135deg, #0077b5, #005fa3)"
                  : "#0a66c2",
          
              transition: "background 0.2s ease, transform 0.2s ease",
              transform: hovered && member.linkedin ? "scale(1.12)" : "scale(1)",
              boxShadow:
                hovered && member.linkedin
                  ? "0 4px 12px rgba(10, 102, 194, 0.4)"
                  : "none",
            }}
            aria-label={`${member.name} LinkedIn`}
          >
            <LinkedInIcon />
          </a>
    </div>
  );
};

const TeamSection = ({ title, highlight, members, isFirst = false }) => (
  <div
    className={`flex items-center justify-center  px-6 py-12 ${!isFirst ? "mb-10" : "mb-16"}`}
    style={{
      background:
        "linear-gradient(160deg, #e0f2fe 0%, #f0f9ff 50%, #e0f2fe 100%)",
      fontFamily: "'Segoe UI', system-ui, sans-serif",
    }}
  >
    <div className="w-full max-w-7xl">
      <h2
        className="text-center font-bold mb-14 text-2xl md:text-3xl lg:text-5xl"
        style={{ animation: "titleFade 0.5s ease both", color: "#1e293b" }}
      >
        {title} <span style={{ color: "#0ea5e9" }}>{highlight}</span>
      </h2>

      <div className="flex flex-wrap justify-center gap-8 ">
        {members.map((member, index) => (
          <MemberCard
            key={`${member.name}-${index}`}
            member={member}
            index={index}
          />
        ))}
      </div>
    </div>
  </div>
);

// ── Page ──────────────────────────────────────────────────────────────────────
export default function FoundingTeam() {
  return (
    <>
      <style>{`
        @keyframes fadeSlideUp {
          from { opacity: 0; transform: translateY(24px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes titleFade {
          from { opacity: 0; transform: translateY(-12px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>

      {SECTIONS.map(({ title, highlight, members }, i) => (
        <TeamSection
          key={`${title}-${highlight}`}
          title={title}
          highlight={highlight}
          members={members}
          isFirst={i === 4}
        />
      ))}
    </>
  );
}